// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"0e395397","658":"2c9eca54"}[chunkId] + ".chunk.css";
};